import { memo, useEffect, useRef } from 'react'
import { Box, Typography } from '@mui/material'
import { isEmpty } from 'lodash'

interface ErrorBlockProps {
  error?: string
  className?: string
  scrollToErrors?: boolean
}

function ErrorBlock({
  error,
  className,
  scrollToErrors = false,
}: ErrorBlockProps) {
  const errorRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!isEmpty(error) && errorRef.current && scrollToErrors) {
      errorRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [error, scrollToErrors])

  if (isEmpty(error)) {
    return null
  }

  return (
    <Box ref={errorRef} className={className}>
      <Typography
        color="error"
        variant="body2"
        className="font-fontWeightMedium"
      >
        {error}
      </Typography>
    </Box>
  )
}

export default memo(ErrorBlock)
